var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("img", {
        staticClass: "account-verification__step__icon",
        class: _vm.additionalCustomIconStyles,
        attrs: { src: _vm.icon },
      }),
      _vm._v(" "),
      _c("h1", { staticClass: "account-verification__step__title" }, [
        _vm._v("\n    " + _vm._s(_vm.title) + "\n  "),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "account-verification__step__description" }, [
        _vm._v("\n    " + _vm._s(_vm.description) + "\n  "),
      ]),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass:
            "account-verification__step__description account-verification__step__data",
        },
        [_vm._v("\n    " + _vm._s(_vm.confirmationData) + "\n  ")]
      ),
      _vm._v(" "),
      !_vm.isProcessing
        ? _c(
            "div",
            {
              staticClass:
                "account-verification__step__buttons-container account-verification__step__buttons-container__ring",
            },
            [
              _c(
                "el-button",
                {
                  staticClass:
                    "account-verification__step__button account-verification__step__button-white",
                  class: _vm.backButtonVisibility,
                  attrs: { plain: "", type: "primary" },
                  on: { click: _vm.notifyBack },
                },
                [_vm._v("\n      " + _vm._s(_vm.backButtonText) + "\n    ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "account-verification__step__button",
                  attrs: { type: "primary" },
                  on: { click: _vm.sendNotification },
                },
                [_vm._v("\n      " + _vm._s(_vm.processButtonText) + "\n    ")]
              ),
            ],
            1
          )
        : _vm.isProcessing
        ? _c("processing-info", {
            staticClass: "email-confirmation__processing-info",
            style: _vm.additionalProcessingInfoStyles,
            attrs: {
              message: _vm.processingMessage,
              "info-type": _vm.processingInfoType,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }